"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { FiPlus, FiEdit2, FiTrash2, FiBarChart2 } from "react-icons/fi"
import "./Departments.css"

const Departments = () => {
  const [departments, setDepartments] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showStatsModal, setShowStatsModal] = useState(false)
  const [selectedDept, setSelectedDept] = useState(null)
  const [stats, setStats] = useState(null)
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    is_active: true,
  })
  const [error, setError] = useState("")

  useEffect(() => {
    loadDepartments()
  }, [])

  const loadDepartments = async () => {
    try {
      const response = await api.get("/departments")
      setDepartments(response.data)
    } catch (error) {
      console.error("Departmanlar yüklenemedi:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    try {
      if (selectedDept) {
        await api.put(`/departments/${selectedDept.id}`, formData)
      } else {
        await api.post("/departments", formData)
      }
      setShowModal(false)
      resetForm()
      loadDepartments()
    } catch (error) {
      setError(error.response?.data?.message || "İşlem başarısız")
    }
  }

  const handleDelete = async (id) => {
    if (!window.confirm("Bu departmanı silmek istediğinizden emin misiniz?")) return

    try {
      await api.delete(`/departments/${id}`)
      loadDepartments()
    } catch (error) {
      alert("Silme işlemi başarısız")
    }
  }

  const handleEdit = (dept) => {
    setSelectedDept(dept)
    setFormData({
      name: dept.name,
      description: dept.description || "",
      is_active: dept.is_active,
    })
    setShowModal(true)
  }

  const handleViewStats = async (dept) => {
    try {
      const response = await api.get(`/departments/${dept.id}/statistics`)
      setStats(response.data)
      setSelectedDept(dept)
      setShowStatsModal(true)
    } catch (error) {
      alert("İstatistikler yüklenemedi")
    }
  }

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      is_active: true,
    })
    setSelectedDept(null)
    setError("")
  }

  if (loading) {
    return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
  }

  return React.createElement(
    "div",
    { className: "departments-page" },
    React.createElement(
      "div",
      { className: "page-header" },
      React.createElement("h1", null, "Departman Yönetimi"),
      React.createElement(
        "button",
        {
          className: "btn btn-primary",
          onClick: () => {
            resetForm()
            setShowModal(true)
          },
        },
        React.createElement(FiPlus),
        "Yeni Departman",
      ),
    ),
    React.createElement(
      "div",
      { className: "departments-grid" },
      departments.map((dept) =>
        React.createElement(
          "div",
          { key: dept.id, className: "dept-card" },
          React.createElement(
            "div",
            { className: "dept-header" },
            React.createElement("h3", null, dept.name),
            React.createElement(
              "span",
              { className: `badge ${dept.is_active ? "badge-success" : "badge-danger"}` },
              dept.is_active ? "Aktif" : "Pasif",
            ),
          ),
          dept.description && React.createElement("p", { className: "dept-description" }, dept.description),
          React.createElement(
            "div",
            { className: "dept-stats" },
            React.createElement("span", null, `${dept.users_count || 0} Personel`),
          ),
          React.createElement(
            "div",
            { className: "dept-actions" },
            React.createElement(
              "button",
              { className: "btn btn-outline", onClick: () => handleViewStats(dept) },
              React.createElement(FiBarChart2),
              "İstatistikler",
            ),
            React.createElement(
              "button",
              { className: "btn-icon", onClick: () => handleEdit(dept) },
              React.createElement(FiEdit2),
            ),
            React.createElement(
              "button",
              { className: "btn-icon danger", onClick: () => handleDelete(dept.id) },
              React.createElement(FiTrash2),
            ),
          ),
        ),
      ),
    ),
    showModal &&
      React.createElement(
        "div",
        { className: "modal-overlay", onClick: () => setShowModal(false) },
        React.createElement(
          "div",
          { className: "modal", onClick: (e) => e.stopPropagation() },
          React.createElement("h2", null, selectedDept ? "Departman Düzenle" : "Yeni Departman"),
          error && React.createElement("div", { className: "error-message" }, error),
          React.createElement(
            "form",
            { onSubmit: handleSubmit },
            React.createElement(
              "div",
              { className: "input-group" },
              React.createElement("label", null, "Departman Adı *"),
              React.createElement("input", {
                type: "text",
                value: formData.name,
                onChange: (e) => setFormData({ ...formData, name: e.target.value }),
                required: true,
              }),
            ),
            React.createElement(
              "div",
              { className: "input-group" },
              React.createElement("label", null, "Açıklama"),
              React.createElement("textarea", {
                value: formData.description,
                onChange: (e) => setFormData({ ...formData, description: e.target.value }),
              }),
            ),
            React.createElement(
              "div",
              { className: "input-group" },
              React.createElement(
                "label",
                { className: "checkbox-label" },
                React.createElement("input", {
                  type: "checkbox",
                  checked: formData.is_active,
                  onChange: (e) => setFormData({ ...formData, is_active: e.target.checked }),
                }),
                React.createElement("span", null, "Aktif"),
              ),
            ),
            React.createElement(
              "div",
              { className: "modal-actions" },
              React.createElement(
                "button",
                { type: "button", className: "btn btn-secondary", onClick: () => setShowModal(false) },
                "İptal",
              ),
              React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Kaydet"),
            ),
          ),
        ),
      ),
    showStatsModal &&
      selectedDept &&
      React.createElement(
        "div",
        { className: "modal-overlay", onClick: () => setShowStatsModal(false) },
        React.createElement(
          "div",
          { className: "modal", onClick: (e) => e.stopPropagation() },
          React.createElement("h2", null, `${selectedDept.name} - İstatistikler`),
          React.createElement(
            "div",
            { className: "stats-grid" },
            React.createElement(
              "div",
              { className: "stat-item" },
              React.createElement("strong", null, "Müşteri Sayısı"),
              React.createElement("span", null, stats?.customer_count || 0),
            ),
            React.createElement(
              "div",
              { className: "stat-item" },
              React.createElement("strong", null, "Toplam Gelir"),
              React.createElement("span", null, `₺${stats?.total_income?.toLocaleString() || 0}`),
            ),
            React.createElement(
              "div",
              { className: "stat-item" },
              React.createElement("strong", null, "Toplam Gider"),
              React.createElement("span", null, `₺${stats?.total_expense?.toLocaleString() || 0}`),
            ),
            React.createElement(
              "div",
              { className: "stat-item" },
              React.createElement("strong", null, "Net Kar"),
              React.createElement(
                "span",
                { className: stats?.net_profit >= 0 ? "text-success" : "text-danger" },
                `₺${stats?.net_profit?.toLocaleString() || 0}`,
              ),
            ),
          ),
          React.createElement(
            "div",
            { className: "modal-actions" },
            React.createElement(
              "button",
              { className: "btn btn-secondary", onClick: () => setShowStatsModal(false) },
              "Kapat",
            ),
          ),
        ),
      ),
  )
}

export default Departments
